export default __webpack_public_path__ + "static/banner-57d70f3f845bbd5c1935747a7857560d.jpg";